import React, { useState } from "react";
import "./paymentPage.css";
import logo from "../../assets/checkout-page-images/logo.png";
import origami from "../../assets/checkout-page-images/origami.jpeg";
import finspirationLogo from "../../assets/checkout-page-images/finspirationLogo.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkIcon from "@mui/icons-material/Link";
import {
  TextField,
  Box,
  FormControl,
  InputLabel,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  OutlinedInput,
  Grid
} from "@mui/material";
import PaymentDetailsBackground from "../../assets/checkout-page-images/PaymentDetailsBackground.png"
import favicon from "../../assets/checkout-page-images/favicon.png"

export const OrigamiWorkshopPayment = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    studentName: "",
    schoolName: "",
    grade: "",
  });

  const [touched, setTouched] = useState({
    name: false,
    phoneNumber: false,
    email: false,
    studentName: false,
    schoolName: false,
    grade: false,
  });

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Phone number validation (Indian format)
  const phoneRegex = /^[6-9]\d{9}$/;

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleBlur = (field) => {
    setTouched((prev) => ({
      ...prev,
      [field]: true,
    }));
  };

  const getErrorMessage = (field) => {
    if (!touched[field] || formData[field].trim() !== "") {
      // Additional validation for specific fields
      if (
        field === "email" &&
        formData[field].trim() !== "" &&
        !emailRegex.test(formData[field])
      ) {
        return "Please enter a valid email address";
      }
      if (
        field === "phoneNumber" &&
        formData[field].trim() !== "" &&
        !phoneRegex.test(formData[field])
      ) {
        return "Please enter a valid 10-digit phone number";
      }
      return "";
    }
    return "This field is required";
  };

  const isError = (field) => {
    const isEmpty = touched[field] && formData[field].trim() === "";
    const isInvalidEmail =
      field === "email" &&
      formData[field].trim() !== "" &&
      !emailRegex.test(formData[field]);
    const isInvalidPhone =
      field === "phoneNumber" &&
      formData[field].trim() !== "" &&
      !phoneRegex.test(formData[field]);

    return isEmpty || isInvalidEmail || isInvalidPhone;
  };

const textFieldSx = {
  mb: 2,
  '& .MuiOutlinedInput-root': {
    height: '40px',
    '& fieldset': {
      borderColor: '#0d2366', // Default border
    },
    '&:hover fieldset': {
      borderColor: '#0d2366', // Hover border
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0d2366', // Focus border
    },
    '&.Mui-error': {
      '& fieldset': {
        borderColor: '#d32f2f', // Keep error red
      },
    },
  },
  '& .MuiInputBase-input': {
    padding: '8px 14px',
    fontSize: '14px',
    color: '#0d2366', // Input text color
  },
  '& .MuiInputLabel-root': {
    top: '-6px',
    color: '#0d2366', // Label color
    '&.MuiInputLabel-shrink': {
      top: '-6px',
      color: '#0d2366', // Shrunk label color
    },
    '&.Mui-focused': {
      color: '#0d2366', // Focused label color
    },
    '&.Mui-error': {
      color: '#d32f2f', // Keep error red
    },
  },
  '& .MuiFormHelperText-root': {
    color: '#0d2366', // Helper text color
    '&.Mui-error': {
      color: '#d32f2f', // Keep error red
    },
  },
};

// payment page begin 
 const [starterQuantity, setStarterQuantity] = useState(1);
  const [refreshmentQuantity, setRefreshmentQuantity] = useState(1);
  const [toolsQuantity, setToolsQuantity] = useState(0);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [preferredDay, setPreferredDay] = useState("--Select--");
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  // const [formData, setFormData] = useState({
  //   email: '',
  //   phone: '',
  //   preferredDay: ''
  // });

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  const days = [
    'Grade 3',
    'Grade 4', 
    'Grade 5',
    'Grade 6',
    'Grade 7',
    'Grade 8',
    
  ];

  const starterPrice = 100.0;
  const refreshmentPrice = 149.0;
  const toolsPrice = 99.0;

  const total =
    starterQuantity * starterPrice +
    refreshmentQuantity * refreshmentPrice +
    toolsQuantity * toolsPrice;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(value));
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    const phoneRegex = /^\d{10}$/;
    setPhoneError(!phoneRegex.test(value));
  };

  const incrementQuantity = (item) => {
    if (item === "starter") setStarterQuantity((prev) => prev + 1);
    if (item === "refreshment") setRefreshmentQuantity((prev) => prev + 1);
    if (item === "tools") setToolsQuantity((prev) => prev + 1);
  };

  const decrementQuantity = (item) => {
    if (item === "starter" && starterQuantity > 0)
      setStarterQuantity((prev) => prev - 1);
    if (item === "refreshment" && refreshmentQuantity > 0)
      setRefreshmentQuantity((prev) => prev - 1);
    if (item === "tools" && toolsQuantity > 0)
      setToolsQuantity((prev) => prev - 1);
  };

  const handleButtonHover = (e) => {
    e.target.style.backgroundColor = "#f3f4f6";
  };

  const handleButtonLeave = (e) => {
    e.target.style.backgroundColor = "transparent";
  };

// end

  return (
    <>
      <div className="main-container">
        {/* Left container */}
        <div className="left-container" style={{
        // backgroundImage: `url(${PaymentDetailsBackground})`,
        color:"#ffffff",
        backgroundSize: 'cover',
        // backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh', // or your preferred size
      }}>
          <div className="left-inner-container">
            {/* logo section */}
            <div className="logo-row">
              <img src={finspirationLogo} alt="Logo" className="logo-img" />
              {/* <span className="studio-title">
                Living Arts And Crafts Studio
              </span> */}
            </div>
            {/* section 1 */}
            <div className="inner-container">
              <h1 className="title" 
              // style ={{color:"#ffffff"}}
              >
                Finspire National Financial Literacy Olympiad.
              </h1>
              <p className="description"
              // style ={{color:"#ffffff"}}
              >
                Welcome to the official payment form for Finspiration’s
                educational programs. This fee covers participation, study
                material access, and evaluation. You will receive an Email
                confirmation regarding next steps once your payment is
                completed. Please reach out to us if you need any kind of
                assistance.Empower your child’s financial future—one step begins
                here.{" "}
              </p>
            </div>

            {/* section 2 */}
            {/* <div>
              <h1 className="title">Venue</h1>
              <p className="description">
                Living Arts and Crafts Studio, Koramangala 560102
              </p>
              <img src={origami} className="image" />
            </div> */}
            {/* section 2 ends*/}

            {/* section 3 */}
            {/* <div className="section-3-container">
              <h1 className="title">Timings</h1>
              <p className="description">Monday to Friday - 6 PM to 8 PM</p>
              <img src={origami} className="image" />
            </div> */}
            {/* section 3 ends*/}
            {/* section 4 */}
            <div className="mt-5">
              <h1 className="title" 
              style={{ "font-size": "16px" }}
              // style={{ "font-size": "16px", color:"#ffffff" }}
              >
                Contact Us:
              </h1>

              <div className="contact-us-section">
                {/* <svg
                  width="16"
                  height="16"
                  fill="#0d2366"
                  viewBox="0 0 20 20"
                  //   className="me-2"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg> */}
                <EmailIcon
                  sx={{ fontSize: 20, cursor: "pointer", color: "#0d2366" }}
                />
                <span className="description margin"
                
                >
                  sales@getfinspired.com
                </span>
              </div>

              <div className="contact-us-section">
                {/* <svg width="16" height="16" fill="#0d2366" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg> */}
                <PhoneIcon
                  sx={{ fontSize: 20, cursor: "pointer", color: "#0d2366" }}
                />
                <span className="description margin">+91 9440404625</span>
              </div>

              <div className="contact-us-section">
                <WhatsAppIcon
                  sx={{ fontSize: 20, cursor: "pointer", color: "#0d2366" }}
                />
                <span className="description" style={{ "margin-left": "8px" }}>
                  +91 9440404625
                </span>
              </div>

              <div className="contact-us-section">
                <a
                  href="https://www.getfinspired.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <LinkIcon
                    sx={{ fontSize: 20, cursor: "pointer", color: "#0d2366" }}
                  />
                  <span
                    className="description"
                    style={{ "margin-left": "8px" }}
                  >
                    https://www.getfinspired.com/
                  </span>
                </a>
              </div>
            </div>

            {/* section 4 ends */}
            {/* section 5 begins */}
            {/* <div style = {{"margin-top": "30px"}}>
              <h1 className="title" style = {{"font-size": "16px"}}>Terms & Conditions:</h1>
              <p className="description">
                You agree to share information entered on this page with Living
                Arts And Crafts Studio (owner of this page) and Razorpay,
                adhering to applicable laws.
              </p>
            </div> */}

            {/* section 5 ends */}
          </div>
          {/* jnjnl */}
        </div>
        {/* Left container end*/}
        {/* Right container */}
        <div className="right-container">
          <img
            
            src={PaymentDetailsBackground}
            alt="Workshop"
            className="right-image"
          />
        </div>
        {/* Right container  end*/}
      </div>

      {/* payment begin */}
      <div class = "payment-main-container">
      <div className="payment-container">
        <h1 className="payment-section-h1"> National Olympiad in Financial Literacy</h1>
        <div className = "payment-main-container-inner-section">

        
        {/* one */}
        <div className = "payment-section-sub-container">
          <p className="payment-section-title">Amount</p>
          <div className = "payment-inner-container">
            <div>
              <div className="payment-section-main-container">
                <img src={favicon} className="payment-section-image" />
                <div className ="vertical-line-2" />

                <span className="payment-section-price">₹ 350</span>
                
              </div>
            </div>
            {/* <p className="payment-section-description">
              Participate in the break out program
            </p> */}
          </div>
        </div>

        {/* two */}
         {/* <div className = "payment-section-sub-container">
          <p className="payment-section-title">Refreshments</p>
          <div className = "payment-inner-container">
            <div>
              <div className="payment-section-main-container">
                <img src={favicon} className="payment-section-image" />
                <div className ="vertical-line-2" />

                <span className="payment-section-price">₹ 500</span>
                <div className="payment-section-container">
                  <button
                    onClick={() => decrementQuantity("starter")}
                    className="payment-section-button payment-section-decrementButton"
                    onMouseEnter={handleButtonHover}
                    onMouseLeave={handleButtonLeave}
                  >
                    −
                  </button>
                  <div className ="vertical-line" />
                  <span className="payment-section-span">{starterQuantity}</span>
                  <div className ="vertical-line" />
                  <button
                    onClick={() => incrementQuantity("starter")}
                    className="payment-section-button payment-section-incrementButton"
                    onMouseEnter={handleButtonHover}
                    onMouseLeave={handleButtonLeave}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <p className="payment-section-description">
              Participate in the break out program
            </p>
          </div>
        </div> */}
        <div className = "form-group sub-container" style ={{marginTop:20}}>
        <label htmlFor="email" className = "form-label">Name</label>
        <input
          type="name"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          className = "form-input"
        />
      </div>
        {/* three */}
        <div className = "form-group sub-container">
        <label htmlFor="email" className = "form-label">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          className = "form-input"
        />
      </div>

      <div className = "form-group sub-container">
        <label htmlFor="phone" className = "form-label">Phone</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          className = "form-input"
        />
      </div>

      {/* student name begin */}
      <div className = "form-group sub-container">
        <label htmlFor="email" className = "form-label">Student Name</label>
        <input
          type="studentName"
          id="studentName"
          name="studentName"
          value={formData.name}
          onChange={handleInputChange}
          className = "form-input"
        />
      </div>

      {/* student name end */}

      <div className = "form-group">
        <div className = "sub-container">

        
        <label htmlFor="preferredDay" className= "form-label">Grade or Class</label>
        <div>

        
        <select
          id="preferredDay"
          name="preferredDay"
          value={formData.preferredDay}
          onChange={handleInputChange}
          className = "form-select"
        >
          <option value="">--Select--</option>
          {days.map(day => (
            <option key={day} value={day}>{day}</option>
          ))}
        </select>
        {/* <p className = "availability-note">The days are subject to availability</p> */}
        </div>
        </div>
        
      </div>

      {/* six */}
      {/* <div className = "payment-section-sub-container">
          <p className="payment-section-title">Refreshments</p>
          <div className = "payment-inner-container">
            <div>
              <div className="payment-section-main-container">
                <img src={favicon} className="payment-section-image" />
                <div className ="vertical-line-2" />

                <span className="payment-section-price">₹ 500</span>
                <div className="payment-section-container">
                  <button
                    onClick={() => decrementQuantity("starter")}
                    className="payment-section-button payment-section-decrementButton"
                    onMouseEnter={handleButtonHover}
                    onMouseLeave={handleButtonLeave}
                  >
                    −
                  </button>
                  <div className ="vertical-line" />
                  <span className="payment-section-span">{starterQuantity}</span>
                  <div className ="vertical-line" />
                  <button
                    onClick={() => incrementQuantity("starter")}
                    className="payment-section-button payment-section-incrementButton"
                    onMouseEnter={handleButtonHover}
                    onMouseLeave={handleButtonLeave}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <p className="payment-section-description">
              Participate in the break out program
            </p>
          </div>
        </div> */}

      {/* end */}
        </div>
        
      </div>
      {/* pay now */}
        <div className = "pay-now-container">
          <img src = "https://cdn.razorpay.com/static/assets/pay_methods_branding.png" className = "pay-now-image"/>
          <p className = "pay-now-button">Pay ₹ 350</p>
        </div>

      </div>
    </>
  );
};
